import { render, staticRenderFns } from "./BullLoader.vue?vue&type=template&id=2765eae2&scoped=true&"
import script from "./BullLoader.vue?vue&type=script&lang=js&"
export * from "./BullLoader.vue?vue&type=script&lang=js&"
import style0 from "./BullLoader.vue?vue&type=style&index=0&id=2765eae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765eae2",
  null
  
)

export default component.exports